import React, { Component } from 'react';
import {
  Text,
  FlatList,
  View,
  KeyboardAvoidingView,
  Dimensions,
  TextInput,
  Modal,
} from 'react-native-web';
import constants from '../global-constants.jsx';
import styles from '../styles/styles.jsx';
import FreqFinder from '../frequency-finder.jsx';

export default class Chat extends Component {

  constructor(props) {
    super(props);
    this.state = {
      result: "none",
      messages: [[1, "message 1"], [0, "message 2"]],
      text_input_value: "",
      position: 2,
      treeTextArray: [],
      treePosition: 3,
      treeModalVisible: false
    };
    this.old_note = "none";
    this.received_message = true;
    this.holding_message = false;

    this.touchAssistTree = [
      { name: "don't do anything", fun: this.doNothing },
      { name: "option L", fun: () => this.callFunctionFor("option L") },
      { name: "option U", fun: () => this.callFunctionFor("option U") },
      { name: "option D", fun: () => this.callFunctionFor("option D") },
      { name: "option R", fun: () => this.callFunctionFor("option R") },
      { name: "option LL", fun: () => this.callFunctionFor("option LL") },
      { name: "option LU", fun: () => this.callFunctionFor("option LU") },
      { name: "option LD", fun: () => this.callFunctionFor("option LD") },
      { name: "option LR", fun: () => this.callFunctionFor("option LR") },
      { name: "option UL", fun: () => this.callFunctionFor("option UL") },
      { name: "option UU", fun: () => this.callFunctionFor("option UU") },
      { name: "option UD", fun: () => this.callFunctionFor("option UD") },
      { name: "option UR", fun: () => this.callFunctionFor("option UR") },
      { name: "option DL", fun: () => this.callFunctionFor("option DL") },
      { name: "option DU", fun: () => this.callFunctionFor("option DU") },
      { name: "option DD", fun: () => this.callFunctionFor("option DD") },
      { name: "option DR", fun: () => this.callFunctionFor("option DR") },
      { name: "option RL", fun: () => this.callFunctionFor("option RL") },
      { name: "option RU", fun: () => this.callFunctionFor("option RU") },
      { name: "option RD", fun: () => this.callFunctionFor("option RD") },
      { name: "option RR", fun: () => this.callFunctionFor("option RR") },
      { name: "option LLL", fun: () => this.callFunctionFor("option LLL") },
      { name: "option LLU", fun: () => this.callFunctionFor("option LLU") },
      { name: "option LLD", fun: () => this.callFunctionFor("option LLD") },
      { name: "option LLR", fun: () => this.callFunctionFor("option LLR") },
      { name: "option LUL", fun: () => this.callFunctionFor("option LUL") },
      { name: "option LUU", fun: () => this.callFunctionFor("option LUU") },
      { name: "option LUD", fun: () => this.callFunctionFor("option LUD") },
      { name: "option LUR", fun: () => this.callFunctionFor("option LUR") },
      { name: "option LDL", fun: () => this.callFunctionFor("option LDL") },
      { name: "option LDU", fun: () => this.callFunctionFor("option LDU") },
      { name: "option LDD", fun: () => this.callFunctionFor("option LDD") },
      { name: "option LDR", fun: () => this.callFunctionFor("option LDR") },
      { name: "option LRL", fun: () => this.callFunctionFor("option LRL") },
      { name: "option LRU", fun: () => this.callFunctionFor("option LRU") },
      { name: "option LRD", fun: () => this.callFunctionFor("option LRD") },
      { name: "option LRR", fun: () => this.callFunctionFor("option LRR") },
      { name: "option ULL", fun: () => this.callFunctionFor("option ULU") },
      { name: "option ULU", fun: () => this.callFunctionFor("option ULU") },
      { name: "option ULD", fun: () => this.callFunctionFor("option ULD") },
      { name: "option ULR", fun: () => this.callFunctionFor("option ULR") },
      { name: "option UUL", fun: () => this.callFunctionFor("option UUL") },
      { name: "option UUU", fun: () => this.callFunctionFor("option UUU") },
      { name: "option UUD", fun: () => this.callFunctionFor("option UUD") },
      { name: "option UUR", fun: () => this.callFunctionFor("option UUR") },
      { name: "option UDL", fun: () => this.callFunctionFor("option UDL") },
      { name: "option UDU", fun: () => this.callFunctionFor("option UDU") },
      { name: "option UDD", fun: () => this.callFunctionFor("option UDD") },
      { name: "option UDR", fun: () => this.callFunctionFor("option UDR") },
      { name: "option URL", fun: () => this.callFunctionFor("option URL") },
      { name: "option URU", fun: () => this.callFunctionFor("option URU") },
      { name: "option URD", fun: () => this.callFunctionFor("option URD") },
      { name: "option URR", fun: () => this.callFunctionFor("option URR") },
      { name: "option DLL", fun: () => this.callFunctionFor("option DLU") },
      { name: "option DLU", fun: () => this.callFunctionFor("option DLU") },
      { name: "option DLD", fun: () => this.callFunctionFor("option DLD") },
      { name: "option DLR", fun: () => this.callFunctionFor("option DLR") },
      { name: "option DUL", fun: () => this.callFunctionFor("option DUL") },
      { name: "option DUU", fun: () => this.callFunctionFor("option DUU") },
      { name: "option DUD", fun: () => this.callFunctionFor("option DUD") },
      { name: "option DUR", fun: () => this.callFunctionFor("option DUR") },
      { name: "option DDL", fun: () => this.callFunctionFor("option DDL") },
      { name: "option DDU", fun: () => this.callFunctionFor("option DDU") },
      { name: "option DDD", fun: () => this.callFunctionFor("option DDD") },
      { name: "option DDR", fun: () => this.callFunctionFor("option DDR") },
      { name: "option DRL", fun: () => this.callFunctionFor("option DRL") },
      { name: "option DRU", fun: () => this.callFunctionFor("option DRU") },
      { name: "option DRD", fun: () => this.callFunctionFor("option DRD") },
      { name: "option DRR", fun: () => this.callFunctionFor("option DRR") },
      { name: "option RLL", fun: () => this.callFunctionFor("option RLU") },
      { name: "option RLU", fun: () => this.callFunctionFor("option RLU") },
      { name: "option RLD", fun: () => this.callFunctionFor("option RLD") },
      { name: "option RLR", fun: () => this.callFunctionFor("option RLR") },
      { name: "option RUL", fun: () => this.callFunctionFor("option RUL") },
      { name: "option RUU", fun: () => this.callFunctionFor("option RUU") },
      { name: "option RUD", fun: () => this.callFunctionFor("option RUD") },
      { name: "option RUR", fun: () => this.callFunctionFor("option RUR") },
      { name: "option RDL", fun: () => this.callFunctionFor("option RDL") },
      { name: "option RDU", fun: () => this.callFunctionFor("option RDU") },
      { name: "option RDD", fun: () => this.callFunctionFor("option RDD") },
      { name: "option RDR", fun: () => this.callFunctionFor("option RDR") },
      { name: "option RRL", fun: () => this.callFunctionFor("option RRL") },
      { name: "option RRU", fun: () => this.callFunctionFor("option RRU") },
      { name: "option RRD", fun: () => this.callFunctionFor("option RRD") },
      { name: "option RRR", fun: () => this.callFunctionFor("option RRR") },
    ];
  }

  callFunctionFor(x) { console.log(x) }
  doNothing() { }

  componentDidMount() {
    console.log(this.props);
    // Initialize and start the frequency finder. 
    this.initializeFreqFinder();
  }

  componentWillUnmount(){
    console.log("unmounting");
    constants.freqfinder.stop();
  }

  initializeFreqFinder() {
    constants.freqfinder = new FreqFinder();
    this.setControlsScheme(this.normalOperation);
    constants.freqfinder.start(150);
  }
  setControlsScheme(controlStructure) {
    constants.freqfinder.action = (note) => {
      if (note !== this.old_note) {
        let newState = this.state;
        if (note === "none") {
          controlStructure.bind(this)();
        }
        this.old_note = note;
        newState.result = note;
        this.setState(newState);
      }
    }
  }
  normalOperation() {
    let newState = this.state;
    if (this.old_note === "special" && this.holding_message === false) {
      constants.freqfinder.stop();


      let sr = window.SpeechRecognition ||
        window.webkitSpeechRecognition ||
        window.mozSpeechRecognition ||
        window.msSpeechRecognition ||
        window.oSpeechRecognition;

      let recognition = new sr();
      recognition.lang = 'en-US';
      recognition.interimResults = false;
      recognition.continuous = false;
      recognition.onresult = (event) => {
        this.received_message = true;
        let message = event.results[0][0].transcript;
        let new_state = this.state;
        new_state.text_input_value = message;
        this.setState(new_state);
        this.initializeFreqFinder();
      }
      recognition.start();

      this.received_message = false;
      this.holding_message = true;
    }
    else if (this.old_note === "special" && this.holding_message === true) {
      this.post_message(this.state.text_input_value);
      this.holding_message = false;
    }
    else if (this.old_note === "down") {
      newState.position = this.state.position + 1 >
        this.state.messages.length ?
        this.state.messages.length :
        this.state.position + 1;
    }
    else if (this.old_note === "up") {
      newState.position = this.state.position - 1 <
        0 ?
        0 :
        this.state.position - 1;
    }
    else if (this.old_note === "special2") {
      newState.treePosition = 0;
      newState.treeTextArray = ["left", "up", "down", "right"];
      newState.treeTextArray = (newState.treeTextArray).concat(this.getTwoGenerations(newState.treePosition));
      newState.treeModalVisible = true;
      this.setControlsScheme(this.touchAssistTreeControls);
    }
    else if (newState.position !== newState.messages.length) {
      // left is delete
      if (this.old_note === "left") {
        for (let i = newState.messages.length - 1; ; i--) {
          if (i === newState.position) { break; }
          newState.messages[i][0] -= 1;
        }
        newState.messages.splice((newState.messages.length - 1) - newState.position, 1);
        newState.position -= 1;
      }
      // right is copy
      else if (this.old_note === "right") {
        newState.text_input_value = newState.messages[newState.position][1];
      }
    }
  }

  getTwoGenerations(position) {
    let output = [];
    let children_position = (position * 4) + 1;
    let grand_children_position = (children_position * 4) + 1;
    let tree = this.touchAssistTree;

    if (children_position < tree.length) {
      let slice_end = tree.length < (children_position + 4) ? tree.length : (children_position + 4);
      let nodes = tree.slice(children_position, slice_end);
      if (grand_children_position < tree.length) {
        slice_end = tree.length < (grand_children_position + 16) ? tree.length : (grand_children_position + 16);
        nodes = nodes.concat(tree.slice(grand_children_position, slice_end));
      }
      output = nodes.map((node) => {
        return node.name;
      });
    }
    if (20 - output.length > 0) {
      output = output.concat(Array(20 - output.length).fill(""));
    }
    return output;
  }

  touchAssistTreeControls() {
    let newState = this.state;
    if (this.old_note === "special") {
      (this.touchAssistTree[newState.treePosition].fun)();
      newState.treeModalVisible = false;
      this.setControlsScheme(this.normalOperation);
      return;
    }
    if (this.old_note === "special2") { return; }
    newState.treePosition *= 4;
    if (this.old_note === "left") {
      newState.treePosition += 1;
    } else if (this.old_note === "up") {
      newState.treePosition += 2;
    } else if (this.old_note === "down") {
      newState.treePosition += 3;
    } else if (this.old_note === "right") {
      newState.treePosition += 4;
    }
    if (newState.treePosition >= this.touchAssistTree.length) {
      newState.treeModalVisible = false;
      this.setControlsScheme(this.normalOperation);
      return;
    }
    newState.treeTextArray = newState.treeTextArray.slice(0, -16);
    newState.treeTextArray = newState.treeTextArray.concat(this.getTwoGenerations(newState.treePosition));
  }

  post_message(message) {
    let new_state = this.state;
    if (new_state.position === 0) {
      new_state.position += 1;
    }
    new_state.messages.unshift([new_state.messages.length, message]);
    new_state.text_input_value = "";
    this.setState(new_state);
  }

  createTable() {
    let rows = [];
    // textArray = ["left", "up", "down", "right", "option L", "option U", "option D", "option R", "option LL", "option LU", "option LD", "option LR", "option UL", "option UU", "option UD", "option UR", "option DL", "option DU", "option DD", "option DR", "option RL", "option RU", "option RD", "option RR"];
    let textArray = this.state.treeTextArray;
    let colors = ["powderblue", "skyblue"];
    let color1 = 1;
    let color2 = 0;

    let i = 0;
    for (; i < textArray.length - 24; i += 4) {
      color1 = Math.abs((i / 4) % 2);
      color2 = 1 - color1;
      rows.push(
        <View style={{ height: 50, flexDirection: 'row' }} key={i}>
          <View style={{ flex: 1, backgroundColor: colors[color1] }}>
            <Text>{textArray[i]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors[color2] }}>
            <Text>{textArray[i + 1]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors[color1] }}>
            <Text>{textArray[i + 2]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors[color2] }}>
            <Text>{textArray[i + 3]}</Text>
          </View>
        </View>
      );
    }

    if (i < textArray.length - 20) {
      color1 = Math.abs((i / 4) % 2);
      color2 = 1 - color1;
      let colors2 = [colors[color1], colors[color2], colors[color1], colors[color2]];
      if (this.state.treePosition !== 0) {
        colors2[(this.state.treePosition - 1) % 4] = "red";
      }
      rows.push(
        <View style={{ height: 50, flexDirection: 'row' }} key={i}>
          <View style={{ flex: 1, backgroundColor: colors2[0] }}>
            <Text>{textArray[i]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors2[1] }}>
            <Text>{textArray[i + 1]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors2[2] }}>
            <Text>{textArray[i + 2]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors2[3] }}>
            <Text>{textArray[i + 3]}</Text>
          </View>
        </View>
      );
      i += 4;
    }

    for (; i < textArray.length; i += 4) {
      if (textArray[i] === "") {
        break;
      }
      color1 = Math.abs((i / 4) % 2);
      color2 = 1 - color1;
      rows.push(
        <View style={{ height: 50, flexDirection: 'row' }} key={i}>
          <View style={{ flex: 1, backgroundColor: colors[color1] }}>
            <Text>{textArray[i]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors[color2] }}>
            <Text>{textArray[i + 1]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors[color1] }}>
            <Text>{textArray[i + 2]}</Text>
          </View>
          <View style={{ flex: 1, backgroundColor: colors[color2] }}>
            <Text>{textArray[i + 3]}</Text>
          </View>
        </View>
      );
    }
    return (<View><Text>{this.state.result}</Text>
      {rows}</View>);
  }

  render() {
    return (<KeyboardAvoidingView
      style={{ flex: 1 }}
      behavior="padding"
    >
      <Modal
        transparent={true}
        visible={this.state.treeModalVisible}
      >
        {this.createTable()}
      </Modal>
      <Text></Text>
      <Text>{this.state.result}</Text>
      <View
        style={{ flex: 1 }}
      >
        <FlatList
          inverted
          style={{ height: Dimensions.get("window").height * (2 / 3) }}
          data={this.state.messages}
          keyExtractor={(item) => item[0].toString()}
          renderItem={({ item }) => (
            <View>
              <Text></Text>
              <Text style={item[0] === this.state.position ? styles.border : {}}
              >{item[1]}</Text>
              <Text></Text>
            </View>
          )}
          ItemSeparatorComponent={() => (<View style={styles.borderSeparator} />)}
          alwaysBounceVertical={true}
        />
      </View>

      <TextInput

        autoFocus={false}
        placeholder="message"
        keyboardType="default"
        returnKeyType="done"
        style={{ height: 40, borderColor: 'gray', borderWidth: 1, textAlign: "center" }}
        onSubmitEditing={
          (event) => {
            let new_message = event.nativeEvent.text;
            this.post_message(new_message);
          }
        }
        onChangeText={(text) => {
          let new_state = this.state
          new_state.text_input_value = text
          this.setState(new_state)
        }}
        value={this.state.text_input_value}
      >
      </TextInput>
    </KeyboardAvoidingView>);
  }

}


